// extracted by mini-css-extract-plugin
export var dataCell = "_qu-2";
export var dataRow = "_qu-0";
export var headerRow = "_qu-1";